import {
	managementConstants
}from "./constants"
import {
	defAction
}from "../../../helpers/defaultAction"
import api from "./api"
import downloadFile from "../../../helpers/downloadFile"
import Notifications from "../../../helpers/Notifications"
import {
	message
}from "antd"
import i18nGlobal from "../../../localization"
import isRu from "../../../helpers/isRu"

export const managementActions = {
	getUsers,
	getOrgUsers,
	getUser,
	getOrgUser,
	getOrgUserList,
	clearOrgUser,
	block,
	unblock,
	clearUserExecut,
	getUserExecut,
	getUserExecutHistory,
	clearUserExecutHistory,
	setUserExecut,
	setTempExternalAdmin,
	unsetTempExternalAdmin,
	removeUserFromReOrg,
	getRemovedOrgUsers,
	inviteToReOrg,
	getInvitations,
	getInvitation,
	responseToInvitation,
	createDisciplinaryAction,
	getDisciplinaryActions,
	clearDisciplinaryActions,
	changeRoles,
	addChildOrg,
	removeChildOrg,
	getChildOrgs,
	getChildInfo,
	getChildOrgInvitation,
	getChildOrgInvitations,
	responseToChildOrgInvitation,
	getOrganizationUnits,
	changeOrganizationUnit,
	deleteRestoreOrganizationUnit,
	clearOrganizationUnits,
	removeDisciplinaryActions,
	reassignOrgUser,
	getSubunitOrgsList,
	clearSubunitOrgs,
	deleteUserIdentificationNumber,
	clearDeleteUserIdentificationNumberReduce,
	changeOrgUnitToOrg,
	clearChangeOrgUnitToOrgReduce,
	exportRegisteredOrgsToExcel,
	setExternalAdminToSelfRegistratedJurdical,
	clearExternalAdminToSelfRegistratedJurdicalValues,
	clearIsBlockedUnblockedValues,
	getUsersForRegistration,
	clearUsersForRegistration,
	getSignersForResolution,
	clearSignersForResolution,
	getResponsibleManagersForResolution,
	clearResponsibleManagersForResolution,
	getExecutorsForResolution,
	clearExecutorsForResolution
}

function changeOrgUnitToOrg(values){
	const dispatchObj = {
		constants : managementConstants.ChangeOrgUnitToOrg,
		service   : {
			func   : api.changeOrgUnitToOrg,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearChangeOrgUnitToOrgReduce(){
	return (dispatch) => dispatch({
		type: managementConstants.ChangeOrgUnitToOrg.CLEAR
	})
}

function deleteUserIdentificationNumber(values){
	const dispatchObj = {
		constants : managementConstants.DeleteUserIdentificationNumber,
		service   : {
			func   : api.deleteUserIdentificationNumber,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearDeleteUserIdentificationNumberReduce(){
	return (dispatch) => dispatch({
		type: managementConstants.DeleteUserIdentificationNumber.CLEAR
	})
}

function reassignOrgUser(values){
	const dispatchObj = {
		constants : managementConstants.ReassignOrgUser,
		service   : {
			func   : api.reassignOrgUser,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getSubunitOrgsList(values){
	const dispatchObj = {
		constants : managementConstants.GetSubunitOrgsList,
		service   : {
			func   : api.getSubunitOrgsList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearSubunitOrgs(){
	return (dispatch) => dispatch({
		type: managementConstants.GetSubunitOrgsList.CLEAR
	})
}

function getUsers(values){
	const dispatchObj = {
		constants : managementConstants.GetUsers,
		service   : {
			func   : api.getUsers,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getOrgUserList(values){
	const dispatchObj = {
		constants : managementConstants.GetOrgUserList,
		service   : {
			func   : api.getOrgUserList,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getOrgUsers(values){
	const dispatchObj = {
		constants : managementConstants.GetOrgUsers,
		service   : {
			func   : api.getOrgUsers,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getUser(values){
	const dispatchObj = {
		constants : managementConstants.GetUser,
		service   : {
			func   : api.getUser,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getOrgUser(values){
	const dispatchObj = {
		constants : managementConstants.GetOrgUser,
		service   : {
			func   : api.getOrgUser,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function clearOrgUser(){
	return (dispatch) => dispatch({
		type: managementConstants.GetOrgUser.CLEAR
	})
}

function block(values){
	const dispatchObj = {
		constants : managementConstants.Block,
		service   : {
			func   : api.block,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function unblock(values){
	const dispatchObj = {
		constants : managementConstants.Unblock,
		service   : {
			func   : api.unblock,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getUserExecut(values){
	const dispatchObj = {
		constants : managementConstants.GetUserExecut,
		service   : {
			func   : api.getUserExecut,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getUserExecutHistory(values){
	const dispatchObj = {
		constants : managementConstants.GetUserExecutHistory,
		service   : {
			func   : api.getUserExecutHistory,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function clearUserExecutHistory(){
	return (dispatch) => dispatch({
		type: managementConstants.GetUserExecutHistory.CLEAR
	})
}

function setUserExecut(values){
	const dispatchObj = {
		constants : managementConstants.SetUserExecut,
		service   : {
			func   : api.setUserExecut,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function setTempExternalAdmin(values){
	const dispatchObj = {
		constants : managementConstants.SetTempExternalAdmin,
		service   : {
			func   : api.setTempExternalAdmin,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function unsetTempExternalAdmin(values){
	const dispatchObj = {
		constants : managementConstants.UnsetTempExternalAdmin,
		service   : {
			func   : api.unsetTempExternalAdmin,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function removeUserFromReOrg(values){
	const dispatchObj = {
		constants : managementConstants.RemoveUserFromReOrg,
		service   : {
			func   : api.removeUserFromReOrg,
			params : values
		}
	}

	return defAction(dispatchObj)
}
function removeDisciplinaryActions(values){
	const dispatchObj = {
		constants : managementConstants.RemoveDisciplinaryActions,
		service   : {
			func   : api.removeDisciplinaryActions,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getRemovedOrgUsers(values){
	const dispatchObj = {
		constants : managementConstants.GetRemovedOrgUsers,
		service   : {
			func   : api.getRemovedOrgUsers,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function inviteToReOrg(values){
	const dispatchObj = {
		constants : managementConstants.InviteToReOrg,
		service   : {
			func   : api.inviteToReOrg,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getInvitations(values){
	const dispatchObj = {
		constants : managementConstants.GetInvitations,
		service   : {
			func   : api.getInvitations,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getInvitation(values){
	const dispatchObj = {
		constants : managementConstants.GetInvitation,
		service   : {
			func   : api.getInvitation,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function responseToInvitation(values){
	const dispatchObj = {
		constants : managementConstants.ResponseToInvitation,
		service   : {
			func   : api.responseToInvitation,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function createDisciplinaryAction(values){
	const dispatchObj = {
		constants : managementConstants.CreateDisciplinaryAction,
		service   : {
			func   : api.createDisciplinaryAction,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getDisciplinaryActions(values){
	const dispatchObj = {
		constants : managementConstants.GetDisciplinaryActions,
		service   : {
			func   : api.getDisciplinaryActions,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function clearUserExecut(){
	return (dispatch) => dispatch({
		type: managementConstants.GetUserExecut.CLEAR
	})
}

function clearDisciplinaryActions(){
	return (dispatch) => dispatch({
		type: managementConstants.ClearDisciplinaryActions.SUCCESS
	})
}

function changeRoles(values){
	const dispatchObj = {
		constants : managementConstants.ChangeRoles,
		service   : {
			func   : api.changeRoles,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function addChildOrg(values){
	const dispatchObj = {
		constants : managementConstants.AddChildOrg,
		service   : {
			func   : api.addChildOrg,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function removeChildOrg(values){
	const dispatchObj = {
		constants : managementConstants.RemoveChildOrg,
		service   : {
			func   : api.removeChildOrg,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getChildOrgs(values){
	const dispatchObj = {
		constants:
      values.type === "Subsidiary"
      	? managementConstants.ParentChildOrgs
      	: managementConstants.InstitutionChildOrgs,
		service: {
			func   : api.getChildOrgs,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getChildInfo(values){
	const dispatchObj = {
		constants : managementConstants.GetChildInfo,
		service   : {
			func   : api.getChildInfo,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getChildOrgInvitations(values){
	const dispatchObj = {
		constants : managementConstants.GetChildOrgInvitations,
		service   : {
			func   : api.getChildOrgInvitations,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getChildOrgInvitation(values){
	const dispatchObj = {
		constants : managementConstants.GetChildOrgInvitation,
		service   : {
			func   : api.getChildOrgInvitation,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function responseToChildOrgInvitation(values){
	const dispatchObj = {
		constants : managementConstants.ResponseToChildOrgInvitation,
		service   : {
			func   : api.responseToChildOrgInvitation,
			params : values
		}
	}

	return defAction(dispatchObj)
}

function getOrganizationUnits(values){
	const dispatchObj = {
		constants : managementConstants.GetOrganizationUnits,
		service   : {
			func   : api.getOrganizationUnits,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function changeOrganizationUnit(values){
	const dispatchObj = {
		constants : managementConstants.ChangeOrganizationUnit,
		service   : {
			func   : api.changeOrganizationUnit,
		}
	}
	return defAction(dispatchObj)
}

function getUsersForRegistration(){
	const dispatchObj = {
		constants : managementConstants.getUsersForRegistration,
		service   : {
			func   : api.getUsersForRegistration,
		}
	}
	return defAction(dispatchObj)
}

function clearUsersForRegistration(){
	return (dispatch) => dispatch({
		type: managementConstants.getUsersForRegistration.CLEAR
	})
}

function getSignersForResolution(){
	const dispatchObj = {
		constants : managementConstants.getSignersForResolution,
		service   : {
			func   : api.getSignersForResolution,
		}
	}
	return defAction(dispatchObj)
}

function clearSignersForResolution(){
	return (dispatch) => dispatch({
		type: managementConstants.getSignersForResolution.CLEAR
	})
}

function getResponsibleManagersForResolution(){
	const dispatchObj = {
		constants : managementConstants.getResponsibleManagersForResolution,
		service   : {
			func   : api.getResponsibleManagersForResolution,
		}
	}
	return defAction(dispatchObj)
}

function clearResponsibleManagersForResolution(){
	return (dispatch) => dispatch({
		type: managementConstants.getResponsibleManagersForResolution.CLEAR
	})
}

function getExecutorsForResolution(values){
	const dispatchObj = {
		constants : managementConstants.getExecutorsForResolution,
		service   : {
			func   : api.getExecutorsForResolution,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearExecutorsForResolution(){
	return (dispatch) => dispatch({
		type: managementConstants.getExecutorsForResolution.CLEAR
	})
}

function deleteRestoreOrganizationUnit(values){
	const dispatchObj = {
		constants : managementConstants.DeleteRestoreOrganizationUnit,
		service   : {
			func   : api.deleteRestoreOrganizationUnit,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function exportRegisteredOrgsToExcel(){
	message.config({
		top: 100
	})
	message.info(i18nGlobal.downloadFileStarted[isRu()])
	const dispatchObj = {
		constants    : managementConstants.ExportRegisteredReOrgsFormExcel,
		failFunction : (err) => {
			Notifications.errorNotice(`${ i18nGlobal.downloadFileError[isRu()] } ${ err }`)
		},
		service: {
			func: api.exportRegisteredOrgsToExcel
		},
		sucFunction: (res) => {
			downloadFile(res, { fileExtension : ".xlsx",
				fileName      : "Зарегистрированные организации" })
		}
	}
	return defAction(dispatchObj)
}

function clearOrganizationUnits(){
	return (dispatch) => dispatch({
		type: managementConstants.GetOrganizationUnits.CLEAR
	})
}

function setExternalAdminToSelfRegistratedJurdical(values){
	const dispatchObj = {
		constants : managementConstants.SetExternalAdminToSelfRegistratedJurdical,
		service   : {
			func   : api.setExternalAdminToSelfRegistratedJurdical,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearExternalAdminToSelfRegistratedJurdicalValues(){
	return (dispatch) => dispatch({
		type: managementConstants.SetExternalAdminToSelfRegistratedJurdical.CLEAR
	})
}

function clearIsBlockedUnblockedValues(){
	return (dispatch) => dispatch({
		type: managementConstants.ClearIsBlockedUnblockedValues
	})
}